export default {
  mutedTextColor: Styles.color.grey.one,
};
